import { collection, getDocs, query, where, orderBy } from 'firebase/firestore';
import { db } from '../config/firebase';
import { BlogPost } from '../data/blog/blog';

const COLLECTION_NAME = 'blogPosts';

// Convert Firebase timestamp to DD/MM/YYYY format
const formatDate = (timestamp: any): string => {
  if (!timestamp) return '';
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

// Convert Firebase document to BlogPost interface
const convertToBlogPost = (doc: any, index: number): BlogPost => {
  const data = doc.data();
  return {
    id: index + 1,
    title: data.title || '',
    desc: data.desc || '',
    date: formatDate(data.date),
    time: data.time || '',
    topic: data.topic || '',
    image: data.image || `/images/posts/blog${index + 1}.jpg`,
    featured: data.featured || false,
    keyword: data.keyword || '',
    content: data.content || '',
    slug: data.slug || '',
  };
};

// Fetch all published blog posts
export const fetchAllPosts = async (): Promise<BlogPost[]> => {
  try {
    const blogRef = collection(db, COLLECTION_NAME);
    const q = query(
      blogRef,
      where('status', '==', 'published'),
      orderBy('date', 'desc')
    );
    const snapshot = await getDocs(q);

    return snapshot.docs.map((doc, index) => convertToBlogPost(doc, index));
  } catch (error) {
    console.error('Error fetching blog posts:', error);
    return [];
  }
};

// Fetch featured posts only
export const fetchFeaturedPosts = async (): Promise<BlogPost[]> => {
  try {
    const blogRef = collection(db, COLLECTION_NAME);
    const q = query(
      blogRef,
      where('status', '==', 'published'),
      where('featured', '==', true),
      orderBy('date', 'desc')
    );
    const snapshot = await getDocs(q);

    return snapshot.docs.map((doc, index) => convertToBlogPost(doc, index));
  } catch (error) {
    console.error('Error fetching featured posts:', error);
    return [];
  }
};

// Fetch single post by slug
export const fetchPostBySlug = async (slug: string): Promise<BlogPost | null> => {
  try {
    const blogRef = collection(db, COLLECTION_NAME);
    const q = query(
      blogRef,
      where('slug', '==', slug),
      where('status', '==', 'published')
    );
    const snapshot = await getDocs(q);

    if (snapshot.empty) return null;
    return convertToBlogPost(snapshot.docs[0], 0);
  } catch (error) {
    console.error('Error fetching post by slug:', error);
    return null;
  }
};
